import React from 'react';
import { TouchableOpacity, TouchableOpacityProps, View } from 'react-native';
import styled from 'styled-components/native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import { useTheme } from '@theme/ThemeProvider';
import { Text } from './Text';

interface ListRowProps extends Omit<TouchableOpacityProps, 'style'> {
  title: string;
  subtitle?: string;
  leftIcon?: string;
  rightIcon?: string;
  rightElement?: React.ReactNode;
  divider?: boolean;
}

const RowContainer = styled(TouchableOpacity)<{ divider: boolean }>`
  flex-direction: row;
  align-items: center;
  padding-vertical: ${({ theme }) => theme.spacing.base}px;
  padding-horizontal: ${({ theme }) => theme.spacing.base}px;
  min-height: ${({ theme }) => theme.minTouchTarget}px;
  background-color: ${({ theme }) => theme.colors.surface};
  border-bottom-width: ${({ divider }) => (divider ? 1 : 0)}px;
  border-bottom-color: ${({ theme }) => theme.colors.divider};
`;

const LeftIconWrapper = styled.View`
  margin-right: ${({ theme }) => theme.spacing.md}px;
`;

const Content = styled.View`
  flex: 1;
  justify-content: center;
`;

const RightContent = styled.View`
  margin-left: ${({ theme }) => theme.spacing.md}px;
  flex-direction: row;
  align-items: center;
`;

export const ListRow: React.FC<ListRowProps> = ({
  title,
  subtitle,
  leftIcon,
  rightIcon,
  rightElement,
  divider = true,
  ...props
}) => {
  const theme = useTheme();

  return (
    <RowContainer divider={divider} activeOpacity={props.onPress ? 0.7 : 1} {...props}>
      {leftIcon && (
        <LeftIconWrapper>
          <Icon name={leftIcon} size={24} color={theme.colors.textSecondary} />
        </LeftIconWrapper>
      )}
      <Content>
        <Text variant="body" color="textPrimary">
          {title}
        </Text>
        {subtitle && (
          <Text variant="bodySmall" color="textSecondary" style={{ marginTop: 2 }}>
            {subtitle}
          </Text>
        )}
      </Content>
      {rightElement && <RightContent>{rightElement}</RightContent>}
      {rightIcon && (
        <RightContent>
          <Icon name={rightIcon} size={20} color={theme.colors.textTertiary} />
        </RightContent>
      )}
    </RowContainer>
  );
};
